// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMoon as RawLucideMoon } from "lucide-react";
export const LucideMoon = /* @__PURE__ */ createIcon(RawLucideMoon, "LucideMoon", 2);
